export const colors = {
  // Primary
  primaryGold: '#B8860B',
  primaryGoldDark: '#9A7209',

  // Text
  textDark: '#1A1A1A',
  textGray: '#6B7280',
  textLight: '#9CA3AF',

  // Backgrounds
  backgroundWhite: '#FFFFFF',
  backgroundGray: '#F9FAFB',
  backgroundCard: '#F3F4F6',

  // Borders
  borderLight: '#E5E7EB',

  // Status
  success: '#10B981',
  error: '#EF4444',
  warning: '#F59E0B',
  info: '#3B82F6',
};

export const breakpoints = {
  mobile: 768,
  tablet: 1024,
  desktop: 1440,
};

export const categories = ['All', 'Trophies', 'Medals', 'Awards', 'Other'];
